import { createRouter, createWebHistory } from 'vue-router'
import HomeView from "@/views/HomeView.vue";
import CheckInventoryView from "@/views/CheckInventoryView.vue";

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    { path: '/', name: 'home', component: HomeView},
    { path: '/checkinventory', name: 'checkinventory', component: CheckInventoryView },
  ]
})

export default router
